import { inject, Injectable } from '@angular/core';
import { IPayment } from '@webapp/quoter/interfaces/payment.interface';
import { StoreService } from '@webapp/core/services/store.service';
import { firstValueFrom } from 'rxjs';

import { QuoterService } from '@webapp/quoter/services/quoter.service';
import { IQuoterPolicy } from '@webapp/quoter/interfaces/quoter.interface';
import { IPaymentLinkQuoteBase } from '@webapp/payment-link/interfaces/payment-link.interface';

export interface PaymentState {
  quote: IPaymentLinkQuoteBase;
  payment: IPayment;
  emitLoading: boolean;
  policy: IQuoterPolicy;
}

@Injectable({
  providedIn: 'root',
})
export class PaymentStoreService extends StoreService<PaymentState> {
  private readonly quoterService = inject(QuoterService);

  constructor() {
    super();
    this.initializeState();
  }
  initializeState() {
    this.setState({
      quote: {} as IPaymentLinkQuoteBase,
      payment: {} as IPayment,
      policy: {} as IQuoterPolicy,
    });
  }

  /**
   * Emitir poliza
   */
  async emit(payment: IPayment): Promise<boolean> {
    try {
      this.set('emitLoading', true);

      const response = await firstValueFrom(
        this.quoterService.emitPaymentLink(
          payment,
          this.state().quote.id,
          this.state().quote.tokenlink
        )
      );
      this.set('policy', response);
      localStorage.setItem('activar_policy', JSON.stringify(response));
      return true;
    } catch (error) {
      console.error('Error al emitir la póliza:', error);
      return false;
    } finally {
      this.set('emitLoading', false);
    }
  }
}
